import { useEffect, useRef, useState, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
  panel: ReactNode | ((close: () => void) => ReactNode);
  className?: string;
  ariaLabel?: string;
}

export function OverflowMenu({ panel, className, ariaLabel = 'Meer opties' }: Props) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);

  const close = () => setOpen(false);
  const rendered = typeof panel === 'function' ? panel(close) : panel;

  return (
    <div className={`app-header-overflow ${className ?? ''}`} ref={containerRef}>
      <button
        type="button"
        className="app-header-overflow-btn"
        onClick={() => setOpen((p) => !p)}
        aria-label={ariaLabel}
        aria-expanded={open}
      >
        <span aria-hidden="true">⋮</span>
      </button>
      {open ? (
        <div className="app-header-overflow-panel" role="menu">
          {rendered}
        </div>
      ) : null}
    </div>
  );
}
